import {Action} from '@ngrx/store';

export enum WebMessagesActionsTypes {
  UPDATE_INITIATE_HANDSHAKE_TOKEN = '[web messages action] update initiate handshake token'
}

export class WebMessagesUpdate implements Action {
  readonly type = WebMessagesActionsTypes.UPDATE_INITIATE_HANDSHAKE_TOKEN;

  constructor(public payload: { value: string }) {
  }
}

export type WebMessagesActions = WebMessagesUpdate;
